.CommandPalette {
    background: var(--soniq-t--global--background--color--surface--panel-opaque);
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    border-radius: 14px;
    overflow: hidden;
}
